module.exports = __webpack_public_path__ + "media/images/entidades_organizadoras/uniao_europeia-3a1ca500730f474f927932e620cb66f1.svg";